import moment from 'moment';

const currentDate = new Date();

const initialState = {
    refferers: {
        result: null,
        filters: {
            city: null,
            createdStartDate: null,
            createdEndDate: null
        },
        loading: false,
        error: null
    },
    popGoods: {
        result: null,
        filters: {
            city: null,
            createdStartDate: moment(currentDate).subtract({ days: 30 }).startOf('day').toDate(),
            createdEndDate: moment(currentDate).endOf('day').toDate(),
        },
        loading: false,
        error: null
    },
    orders: {
        result: null,
        filters: {
            city: null,
            createdStartDate: moment(currentDate).subtract({ days: 15 }).startOf('day').toDate(),
            createdEndDate: moment(currentDate).endOf('day').toDate(),
        },
        loading: false,
        error: null
    },
    ordersOfHead: {
        result: null,
    },
    promocode: {
        result: null,
        filters: {
            city: null,
            createdStartDate: moment(currentDate).subtract({ days: 15 }).startOf('day').toDate(),
            createdEndDate: moment(currentDate).endOf('day').toDate(),
        },
        loading: false,
        error: null
    },
    clients: {
        result: null,
        filters: {
            city: null,
            point: null,
            createdStartDate: moment(currentDate).subtract({ days: 15 }).startOf('day').toDate(),
            createdEndDate: moment(currentDate).endOf('day').toDate(),
        },
        loading: false,
        error: null
    },
    orderGoods: {
        result: null,
        filters: {
            city: null,
            createdStartDate: moment(currentDate).subtract({ days: 15 }).startOf('day').toDate(),
            createdEndDate: moment(currentDate).endOf('day').toDate(),
        },
        loading: false,
        error: null
    },
    pointslogs: {
        result: null,
        filters: {
            city: null,
            createdStartDate: moment(currentDate).subtract({ days: 15 }).startOf('day').toDate(),
            createdEndDate: moment(currentDate).endOf('day').toDate(),
        },
        loading: false,
        error: null
    },
    historyInvoice: {
        result: null,
        filters: {
            point: null,
            points: [],
            createdStartDate: moment(currentDate).subtract({ days: 15 }).toDate(),
            createdEndDate: currentDate,
            category: null,
            supplier: null,
            start: 0,
            limit: 10,
        },
        loading: false,
        error: null
    },
    costprice: {
        result: null,
        filters: {
            type: 'good',
            category: null,
            point: null,
            _start: 0,
            _limit: 10,
        },
        error: null
    },
    movementRaws: {
        result: null,
        filters: {
            date_gt: moment(currentDate).subtract({ days: 15 }).toDate(),
            date_lte: currentDate,
            point: null,
            category: null,
            _start: 0,
            _limit: 10,
            _sort: 'id:ASC',
        },
        error: null
    }
};

export default function statistics(state = initialState, action) {
  switch(action.type) {
        case 'SET_STATISTICS': {
            return {
                ...state,
                [action.name]: {
                    ...state[action.name],
                    result: action.result
                }
            };
        }
        case 'SET_STATISTICS_FILTERS': {
            return {
                ...state,
                [action.name]: {
                    ...state[action.name],
                    filters: action.filters
                }
            };
        }
        case 'RESET_STATISTICS_FILTERS': {
            return {
                ...state,
                [action.name]: {
                    ...state[action.name],
                    filters: initialState[action.name].filters
                }
            };
        }
        case 'SET_STATISTICS_LOADER': {
            return {
                ...state,
                [action.name]: {
                    ...state[action.name],
                    loading: action.loading
                }
            }
        }
        case 'SET_STATISTICS_ERROR': {
            return {
                ...state,
                [action.name]: {
                    ...state[action.name],
                    error: action.error
                }
            }
        }
        default: return state;
    }
}